// THIS FILE IS AUTO-GENERATED BY vite-plugin-api-constructor.
// DO NOT EDIT MANUALLY.

import type { z } from "zod";
import * as R0 from "@/api/users/info";
import * as R1 from "@/api/tracks/index";
import * as R2 from "@/api/courses/index";
import * as R3 from "@/api/reviews/index";
import * as R4 from "@/api/lectures/index";
import * as R5 from "@/api/schedules/index";
import * as R6 from "@/api/semesters/index";
import * as R7 from "@/api/timetables/index";
import * as R8 from "@/api/courses/$courseId";
import * as R9 from "@/api/semesters/current";
import * as R10 from "@/api/sync/requests/index";
import * as R11 from "@/api/sync/requests/active";
import * as R12 from "@/api/courses/auto-complete";
import * as R13 from "@/api/planner-courses/index";
import * as R14 from "@/api/users/writable-review";
import * as R15 from "@/api/users/written-reviews";
import * as R16 from "@/api/users/$userId/lectures";
import * as R17 from "@/api/users/$userId/wishlist";
import * as R18 from "@/api/reviews/$reviewId/index";
import * as R19 from "@/api/reviews/$reviewId/liked";
import * as R20 from "@/api/timetables/$timetableId";
import * as R21 from "@/api/timetables/my-timetable";
import * as R22 from "@/api/department-options/index";
import * as R23 from "@/api/users/$userId/reviews/liked";
import * as R24 from "@/api/users/$userId/planners/index";
import * as R25 from "@/api/sync/requests/$requestId/stream";
import * as R26 from "@/api/users/$userId/interested-departments";
import * as R27 from "@/api/users/$userId/planners/$plannerId/index";
import * as R28 from "@/api/users/$userId/planners/$plannerId/reorder";
import * as R29 from "@/api/timetables/$timetableId/custom-blocks/index";
import * as R30 from "@/api/users/$userId/planners/$plannerId/remove-item";
import * as R31 from "@/api/users/$userId/planners/$plannerId/update-item";
import * as R32 from "@/api/users/$userId/planners/$plannerId/add-future-item";
import * as R33 from "@/api/timetables/$timetableId/custom-blocks/$customblockId";
import * as R34 from "@/api/users/$userId/planners/$plannerId/add-arbitrary-item";

export const requestMap = {
  "/users/info": {
    GET: R0.GETRequest,
  },
  "/tracks": {
    GET: R1.GETRequest,
  },
  "/courses": {
    GET: R2.GETRequest,
  },
  "/reviews": {
    GET: R3.GETRequest,
    POST: R3.POSTRequest,
  },
  "/lectures": {
    GET: R4.GETRequest,
  },
  "/schedules": {
    GET: R5.GETRequest,
  },
  "/semesters": {
    GET: R6.GETRequest,
  },
  "/timetables": {
    GET: R7.GETRequest,
    POST: R7.POSTRequest,
    PATCH: R7.PATCHRequest,
    DELETE: R7.DELETERequest,
  },
  "/courses/:courseId": {
    GET: R8.GETRequest,
  },
  "/semesters/current": {
    GET: R9.GETRequest,
  },
  "/sync/requests": {
    POST: R10.POSTRequest,
  },
  "/sync/requests/active": {
    GET: R11.GETRequest,
  },
  "/courses/auto-complete": {
    GET: R12.GETRequest,
  },
  "/planner-courses": {
    GET: R13.GETRequest,
  },
  "/users/writable-review": {
    GET: R14.GETRequest,
  },
  "/users/written-reviews": {
    GET: R15.GETRequest,
  },
  "/users/:userId/lectures": {
    GET: R16.GETRequest,
  },
  "/users/:userId/wishlist": {
    GET: R17.GETRequest,
    PATCH: R17.PATCHRequest,
  },
  "/reviews/:reviewId": {
    PUT: R18.PUTRequest,
  },
  "/reviews/:reviewId/liked": {
    PATCH: R19.PATCHRequest,
  },
  "/timetables/:timetableId": {
    GET: R20.GETRequest,
    PATCH: R20.PATCHRequest,
  },
  "/timetables/my-timetable": {
    GET: R21.GETRequest,
  },
  "/department-options": {
    GET: R22.GETRequest,
  },
  "/users/:userId/reviews/liked": {
    GET: R23.GETRequest,
  },
  "/users/:userId/planners": {
    GET: R24.GETRequest,
    POST: R24.POSTRequest,
  },
  "/sync/requests/:requestId/stream": {
    GET: R25.GETRequest,
  },
  "/users/:userId/interested-departments": {
    PUT: R26.PUTRequest,
  },
  "/users/:userId/planners/:plannerId": {
    PATCH: R27.PATCHRequest,
    DELETE: R27.DELETERequest,
  },
  "/users/:userId/planners/:plannerId/reorder": {
    POST: R28.POSTRequest,
  },
  "/timetables/:timetableId/custom-blocks": {
    GET: R29.GETRequest,
    POST: R29.POSTRequest,
  },
  "/users/:userId/planners/:plannerId/remove-item": {
    POST: R30.POSTRequest,
  },
  "/users/:userId/planners/:plannerId/update-item": {
    POST: R31.POSTRequest,
  },
  "/users/:userId/planners/:plannerId/add-future-item": {
    POST: R32.POSTRequest,
  },
  "/timetables/:timetableId/custom-blocks/:customblockId": {
    PATCH: R33.PATCHRequest,
    DELETE: R33.DELETERequest,
  },
  "/users/:userId/planners/:plannerId/add-arbitrary-item": {
    POST: R34.POSTRequest,
  },
} as const;

export type APIPath = keyof typeof requestMap;
export type RequestMap = {
  [P in keyof typeof requestMap]: {
    [M in keyof typeof requestMap[P]]: z.infer<(typeof requestMap)[P][M]>;
  }
};

export type RequestOf<P extends APIPath, M extends keyof RequestMap[P]> = RequestMap[P][M];
